import React from 'react';
import { NavLink } from 'react-router-dom';

const Header: React.FC = () => {
  const [scrolled, setScrolled] = React.useState(false);
  const [menuOpen, setMenuOpen] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header id="top" className={`app-header${scrolled ? ' app-header--scrolled' : ''}`}>
      <NavLink to="/" className="header-brand" onClick={closeMenu}>
        <span className="graffiti-tag">FOR THE BOYS</span>
      </NavLink>

      <button
        className={`hamburger${menuOpen ? ' hamburger--open' : ''}`}
        aria-label="Menü öffnen"
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen((v) => !v)}
      >
        <span />
        <span />
        <span />
      </button>

      <nav className={`nav${menuOpen ? ' nav--open' : ''}`} aria-label="Hauptnavigation">
        <NavLink to="/" end className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
          Home
        </NavLink>
        <NavLink to="/about" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
          Über mich
        </NavLink>
        <NavLink to="/warum" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
          Warum?
        </NavLink>
        <NavLink to="/join" className={({ isActive }) => (isActive ? 'active' : '')} onClick={closeMenu}>
          Mitmachen
        </NavLink>
      </nav>
    </header>
  );
};

export default Header;
